import React from "react";
import { ClipboardList, Boxes, AlertTriangle, FileText, AlertCircle } from "lucide-react";

export default function TasksAlerts({ kpis, shipKpis, loading }) {
    const tasks = [
        { icon:ClipboardList, label:"POs Awaiting Dispatch",    count: kpis.posAwaitingDispatch  ?? 0, color:"#3B82F6" },
        { icon:Boxes,         label:"ASNs Awaiting Receipt",    count: kpis.asnsAwaitingReceipt  ?? 0, color:"#10B981" },
        { icon:AlertTriangle, label:"Low Stock Alerts",         count: kpis.lowStock             ?? 0, color:"#F59E0B" },
        { icon:FileText,      label:"Invoices Pending Approval",count: kpis.pendingInvoices      ?? 0, color:"#8B5CF6" },
        { icon:AlertCircle,   label:"Shipment Exceptions",      count: shipKpis.exceptions       ?? 0, color:"#EF4444" },
    ];
    return (
        <div className="bg-[#111827] border border-[#1F2937] rounded-xl p-4 flex-1">
            <p className="text-sm font-bold text-white mb-3">Tasks &amp; Alerts</p>
            <div className="space-y-2.5">
                {tasks.map((t, i) => {
                    const Icon = t.icon;
                    return (
                        <div key={i} className="flex items-center gap-2.5">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                                style={{backgroundColor:`${t.color}22`}}>
                                <Icon size={13} style={{color:t.color}}/>
                            </div>
                            <p className="flex-1 text-xs text-slate-300 min-w-0 truncate">{t.label}</p>
                            <span className="text-sm font-bold tabular-nums shrink-0" style={{color:t.color}}>
                                {loading ? "—" : t.count}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
